import { render, staticRenderFns } from "./DeedsItem.vue?vue&type=template&id=a546911c&scoped=true&"
import script from "./DeedsItem.vue?vue&type=script&lang=js&"
export * from "./DeedsItem.vue?vue&type=script&lang=js&"
import style0 from "./DeedsItem.vue?vue&type=style&index=0&id=a546911c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a546911c",
  null
  
)

export default component.exports